export default __webpack_public_path__ + "static/alexgo-1-bbf3616472d6181f58153e50c917da79.webp";